// ---------------------------------------------------------------------------
// @noxverify/admin-web — route definitions for the admin SPA
// ---------------------------------------------------------------------------

import type { AdminModule } from './app-shell.js';

/** Route definition for the admin SPA */
export interface RouteDefinition {
  path: string;
  module: AdminModule;
  pageKey: string;
  requiredPermission: string;
}

export const ADMIN_ROUTES: RouteDefinition[] = [
  { path: '/platform/tenants', module: 'platform', pageKey: 'tenants', requiredPermission: 'platform.tenants.read' },
  { path: '/platform/members', module: 'platform', pageKey: 'platform-members', requiredPermission: 'platform.members.manage' },
  { path: '/platform/support-sessions', module: 'platform', pageKey: 'support-sessions', requiredPermission: 'platform.support_sessions.read' },
  { path: '/platform/audit-events', module: 'platform', pageKey: 'audit-events', requiredPermission: 'platform.audit.read' },
  { path: '/tenant/projects', module: 'tenant-admin', pageKey: 'projects', requiredPermission: 'tenant.projects.read' },
  { path: '/tenant/domains', module: 'tenant-admin', pageKey: 'domains', requiredPermission: 'project.domains.read' },
  { path: '/tenant/members', module: 'tenant-admin', pageKey: 'members', requiredPermission: 'tenant.members.read' },
  { path: '/tenant/sso', module: 'tenant-admin', pageKey: 'sso', requiredPermission: 'tenant.sso.manage' },
  { path: '/tenant/config', module: 'tenant-admin', pageKey: 'config-promotions', requiredPermission: 'config.read' },
  { path: '/tenant/cases', module: 'tenant-admin', pageKey: 'cases', requiredPermission: 'case.read' },
  { path: '/tenant/webhooks', module: 'tenant-admin', pageKey: 'webhooks', requiredPermission: 'project.webhooks.manage' },
  { path: '/cases/:caseId', module: 'tenant-admin', pageKey: 'case-dossier', requiredPermission: 'case.read' },
  { path: '/analyst/queue', module: 'analyst', pageKey: 'review-queue', requiredPermission: 'review.assign' },
  { path: '/analyst/kyb-review/:entityId', module: 'analyst', pageKey: 'kyb-review', requiredPermission: 'case.read' },
  { path: '/analyst/merchants/:profileId', module: 'analyst', pageKey: 'merchant-review', requiredPermission: 'case.read' },
  { path: '/operations/monitoring', module: 'operations', pageKey: 'monitoring', requiredPermission: 'platform.audit.read' },
  { path: '/operations/analytics', module: 'operations', pageKey: 'analytics', requiredPermission: 'platform.audit.read' },
  { path: '/operations/alerts', module: 'operations', pageKey: 'alerts', requiredPermission: 'platform.audit.read' },
  { path: '/operations/ai-audit', module: 'operations', pageKey: 'ai-audit', requiredPermission: 'platform.audit.read' },
  { path: '/enterprise/runbooks', module: 'enterprise', pageKey: 'runbooks', requiredPermission: 'platform.deployment.manage' },
  { path: '/enterprise/data-governance', module: 'enterprise', pageKey: 'data-governance', requiredPermission: 'platform.deployment.manage' },
  { path: '/enterprise/releases', module: 'enterprise', pageKey: 'releases', requiredPermission: 'platform.deployment.manage' },
];
